import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import Loader from 'components/common-components/Loader';
import { CallAPI } from 'actions/General';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    const code = searchParams.get('code');
    if (code) {
      const response = await CallAPI('VERIFY_EMAIL_VERIFICATION_CODE', { code }, null, setLoading);
      if (response.status) {
        toast.success('Email verified successfully');
      } else {
        toast.error('Email verification failed');
      }
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    verify();
  }, []);

  return <div>{loading && <Loader color='green-1' type='modal-spinner' />}</div>;
};

export default EmailVerification;
